import { css } from 'lit';

export const autocompleteStyles = css` 
    :host {
        --search-input__color: var(--_search-input__color, var(--sbkInputFgColorOnLightDefault));
        --search-input__color--disabled: var(--_search-input__color--disabled, var(--sbkInputFgColorOnLightDisabled));
        --search-inputt__color--error: var(--_search-input__color--error, var(--sbkInputFgColorOnLightError));

        --search-input__bg: var(--_search-input__bg, var(--sbkInputBgColorOnLightEnabled));
        --search-input__bg--active: var(--_search-input__bg--active, var(--sbkInputBgColorOnLightActive));
        --search-input__bg--hover: var(--_search-input__bg--hover, var(--sbkInputBgColorOnLightHover));
        --search-input__bg--focus: var(--_search-input__bg--focus, var(--sbkInputBgColorOnLightFocus));
        --search-input__bg--disabled: var(--_search-input__bg--disabled, var(--sbkInputBgColorOnLightDisabled));
        --search-input__bg--error: var(--_search-input__bg--error, var(--sbkSearchBgColorInputFieldOnLightError));

        --search-input__border: var(--_search-input__border, var(--sbkInputBorderOnLightEnabled));
        --search-input__border--active: var(--_search-input__border--active, var(--sbkInputBorderOnLightActive));
        --search-input__border--disabled: var(--_search-input__border--disabled, var(--sbkInputBorderOnLightDisabled));
        --search-input__border--error: var(--_search-input__border--error, var(--sbkInputBorderOnLightError));
        --search-input__border--focus: var(--_search-input__border--focus, var(--sbkInputBorderOnLightFocus));
        --search-input__border--hover: var(--_search-input__border--hover, var(--sbkInputBorderOnLightHover));
        --search-input__border--readonly: var(--_search-input__border--readonly, var(--sbkInputBorderOnLightDisabled));

        --search-flyout__bg: var(--_search__bg, var(--sbkSelectColorBgColorOnLightFlyoutEnabled));
        --search-flyout-item__bg: var(--_search-flyout-item__bg, var(--sbkSearchBgColorFlyoutEnabled));
        --search-flyout-item__bg--active: var(--_search-flyout-item__bg--active, var(--sbkSearchBgColorFlyoutActive));
        --search-flyout__box-shadow: var(--_search-flyout__box-shadow, var(--sbkSelectFlyoutOnLightShadow));
        --search-option__color: var(--_select-option__color, var(--sbkSelectColorFgColorOnLightDefault));
        --search-option__color--active: var(--_select-option__color--active, var(--sbkSelectColorFgColorOnDarkEnabled));
        --search-option__color--disabled: var(--_select-option__color--disabled, var(--sbkSelectColorFgColorOnLightDisabled));
        --search-option__bg--active: var(--_select-option__bg--active, var(--sbkSelectColorBgColorOnLightFlyoutActive));
    }
    
    * {
        box-sizing: border-box;
    }
    
    .autocomplete__wrapper {
        position: relative;
    }

    #listbox {
        background-color: var(--search-flyout__bg);
        border-radius: var(--sbkSelectBorderRadiusDefault);
        display: none;
        left: 0;
        position: absolute;
        top: 100%;
        width: 100%;
        z-index: 100;
        margin-top: var(--sbkSelectSpacing3xs);
        box-shadow: var(--search-flyout__box-shadow);
        max-height: 300px;
        overflow-y: scroll;
        padding: var(--sbkSelectSpacingXs) 0;

        &.single {
            overflow-y: visible;
        }
    }

    .autocomplete-item {
        cursor: pointer;
        font: var(--sbkSelectTypographyFlyoutSm);
        color: var(--search-option__color);
        padding: var(--sbkSelectListItemSpacingInsetTopBottom) var(--sbkSelectListItemSpacingInsetLeftRight);
        display: flex;
        gap: var(--sbkSearchSpacingInputField3xs);
        background-color: var(--sbkSearchBgColorFlyoutActive);

        sbk-icon {
            padding-right: var(--sbkSelectListItemSpacingIconGap);
        }
    }

    @media (hover: hover) and (pointer: fine) {
        .autocomplete-item:hover {
            background-color: var(--search-option__bg--active);
            color: var(--search-option__color--active);
        }
    }

    .autocomplete-item[aria-selected] {
        background-color: var(--search-option__bg--active);
        color: var(--search-option__color--active);
    }

    .autocomplete-item[disabled] {
      color: var(--sbkSelectColorFgColorOnLightDisabled)
    }

    @media (hover: hover) and (pointer: fine) {
        .autocomplete-item[disabled]:hover {
            background-color: var(--sbkSelectColorBgColorOnLightFlyoutEnabled);
            color: var(--sbkSelectColorFgColorOnLightDisabled);
        }
    }
    
`;